import {Paper, Typography, Stack} from '@mui/material'

interface ChartEmptyStateProps {
  message?: string;
  title?: string;
}

function ChartEmptyState({message = 'No data available for the selected filters', title}: ChartEmptyStateProps) {
  return (
    <Paper elevation={2} sx={{p: 3, minHeight: 400, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <Stack spacing={1} alignItems="center">
        {title && (
          <Typography variant="h5" color="text.secondary" fontWeight="medium">
            {title}
          </Typography>
        )}
        <Typography variant="h6" color="text.secondary">
          {message}
        </Typography>
      </Stack>
    </Paper>
  )
}

export {ChartEmptyState}